module.exports = __webpack_public_path__ + "img/abacas.d8ef88ee.svg";